<template>
  <div class="card-header flex-column flex-md-row align-items-center">
    <div class="d-flex mw-100">
      
      <div class="d-flex mw-100 ml-sm-0 justify-content-center" >
        <div
          class="d-flex align-items-center justify-content-center bloco-box"
          v-for="(item, key) in avaiablePositionsLocal"
          :key="key"
          :class="getClassMarker(item.position)">
          <div class="d-flex flex-column align-items-center justify-content-center pt-3">
              <img src="/static/novomundosenai/imgs/icone-bolinha-indicador-inativo-curriculo.svg" >
              <span class="fake-text-2854" ></span>
              <p class="caption1 color-gray-400 mb-0" :class="getClassTextMarker(item.position)">{{item.text}}</p>
          </div>
          <div class="line" v-if="key != avaiablePositionsLocal.length - 1"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ModelSelectionComponent",
  props: {
    position: Number,
    avaiablePositions: Array,
  },
  computed: {
    positionLocal: {
      get: function () {
        return this.position;
      },
      set: function (value) {
        this.$emit("update:position", value);
      },
    },
    avaiablePositionsLocal: {
      get: function () {
        return this.avaiablePositions;
      },
      set: function (value) {
        this.$emit("update:avaiablePositions", value);
      },
    },
  },
  methods: {
    getClassMarker(clas_pos) {
      return { actual: this.positionLocal >= clas_pos, active: this.positionLocal > clas_pos };
    },
    getClassTextMarker(clas_pos) {
      return { 'v-hidden': this.positionLocal != clas_pos};
    }
  }
};
</script>

<style scoped>
</style>
